import * as Sentry from '@sentry/react';
import { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from '@/pages/login';
import { LoginCallbackPage } from '@/pages/login-callback';
import { AppRoutes } from '@/shared/constants/app-routes.constant';
import { hideZendeskWidget } from '@/shared/lib/helpers/zendesk-widget.helper';
import { PageLoader } from '@/widgets/page';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(({ children }) => <Routes>{children}</Routes>);

const RouterComponent = () => {
	useEffect(() => {
		hideZendeskWidget();
	}, []);

	return (
		<Suspense fallback={<PageLoader />}>
			<SentryRoutes>
				<Route element={<LoginPage />} path={AppRoutes.Login} />
				<Route element={<LoginCallbackPage />} path={AppRoutes.LoginCallback} />
				<Route element={<Navigate to={AppRoutes.Login} />} path="*" />
			</SentryRoutes>
		</Suspense>
	);
};

export default RouterComponent;
